
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 .687c5.692 0 10.312 4.62 10.312 10.312 0 5.692-4.62 10.313-10.312 10.313C5.308 21.312.687 16.69.687 10.999S5.308.687 11 .687zM7.184 15.704l-2.246-3.187a.688.688 0 011.124-.792l2.246 3.187.01.014a.274.274 0 00.445.013l.008-.01 7.19-9.096a.688.688 0 011.078.852l-7.181 9.086a1.649 1.649 0 01-2.674-.067z"}})])
          )
        }
      }
    